import React, { useEffect } from 'react';
import Statistics from '../components/Statistics';
import AdBanner from '../components/AdBanner';
import './StatsPage.css';

function StatsPage() {
  useEffect(() => {
    document.title = '로또 통계 분석 - 로또운세';
  }, []);

  return (
    <div className="stats-page">
      <div className="stats-header">
        <h1>📊 로또 통계 분석</h1>
        <p>최근 당첨 번호를 기반으로 한 통계 및 분석 정보</p>
      </div>

      <AdBanner />

      <main className="main-content">
        <Statistics />
      </main>

      <AdBanner />
    </div>
  );
}

export default StatsPage;
